module.exports = __webpack_public_path__ + "assets/8571fcc6a2155849390b1b3bb24a988c.png";